import React, { useEffect, useRef, useState } from "react";
import DecorativeSquares from "../components/ui/DecorativeSquares";
// import profileImg from "../assets/images/Avatar/02.png";
import QRcode from "../assets/images/other/qrcode.svg";
import { LogOut, LogOutIcon } from "lucide-react";
import { FaWhatsapp } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import { getProfileDetail, getQrCOde } from "../redux/thunks/profileThunk";
import { useNavigate } from "react-router-dom";
import PrimaryBtn from "../components/button/PrimaryBtn";
import { clearToken } from "../redux/slices/authSlice";
import DeleteSwal from "../components/Swals/DeleteSwal";
import { Copy, Download } from "lucide-react";
import screen from "../assets/images/other/Screen.png";
import {
  ChevronRight,
  User,
  HandPlatter,
  Info,
  Package,
  Crown,
  CircleQuestionMark,
  Edit3,
  Phone,
  Mail,
  MessagesSquare,
} from "lucide-react";
import ImagePreview from "../components/ui/ImagePreview";
import toast from "react-hot-toast";

const Profile = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [previewImg, setPreviewImg] = useState(null);
  const [providerName, setProviderName] = useState("");
  const [providerAvtar, setProviderAvtar] = useState(null);
  const [qrImage, setQrImage] = useState(null);
  const [QrLink, setQrLink] = useState(null);
  const [qrData, setqrData] = useState(null);
  const { isLoading } = useSelector((state) => state.profile);
  useEffect(() => {
    dispatch(getProfileDetail())
      .unwrap()
      .then((res) => {
        const username = res.data.name;

        // Step 1a: Decide which image to show first
        const currentImage =
          res.data.user_profile_image || res.data.user_avatar_image || "";

        setProviderName(username);
        setProviderAvtar(currentImage); // use this for profile display
      })
      .catch((err) => console.log("Error:", err));
  }, [dispatch]);
  useEffect(() => {
    const payload = null;
    dispatch(getQrCOde(payload))
      .unwrap()
      .then((res) => {
        const qrDatas = res.data;
        setqrData(qrDatas);
        // console.log("The qr code data is :", res.data);
        const setQr = res.data.user_service_qr_image;
        // console.log("The service qr codeis :", setQr);
        setQrImage(setQr);
        const getLink = res.data.user_service_qr_link;
        setQrLink(getLink);
      });
  }, [dispatch]);

  const onCopyLink = async () => {
    if (!QrLink) return;

    try {
      await navigator.clipboard.writeText(QrLink);
      toast.success("Link copied successfully");
    } catch (err) {
      console.log("Failed to copy link ❌");
    }
  };
  const onDownload = () => {
    if (!qrImage) return;

    const link = document.createElement("a");
    link.href = qrImage;
    link.target = "_blank"; // fallback
    link.setAttribute("download", "tiffintap-qr.png");

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  const fileRef = useRef(null);
  const profileMenus = [
    {
      label: "Personal Details",
      desc: "Name, photo, basic details",
      icon: User,
      path: "/profile/personal-profile",
    },
    {
      label: "Your Service Identity",
      desc: "Manage your service identity",
      icon: Info,
      path: "/profile/edit-service",
    },
    {
      label: "Meal Plans",
      desc: "Add or update meal plans",
      icon: HandPlatter,
      path: "/profile/meals",
      state: { from: "profile" },
    },
    {
      label: "Pick up Information",
      desc: "Manage delivery details",
      icon: Package,
      path: "/profile/update-pickup-address",
    },
    {
      label: "Inquiry",
      desc: "Check Inquiries here",
      icon: MessagesSquare,
      path: "/profile/inquiry",
    },
    {
      label: "Support & Queries",
      desc: "Need help? Talk to us",
      icon: CircleQuestionMark,
      path: "/profile/support",
    },
  ];

  const logout = () => {
    DeleteSwal({
      title: "Logout",
      text: "Are you sure you want to logout?",
      icon: LogOutIcon,
      confirmText: "Logout",
      cancelText: "Cancel",
      cancleColor: "",
      note: "",
      onConfirm: () => {
        localStorage.removeItem("9zIBz91iaMa33UPXalZiOH7mnILWM1af");
        sessionStorage.removeItem("9zIBz91iaMa33UPXalZiOH7mnILWM1af");
        localStorage.removeItem("isAuthenticated");
        localStorage.removeItem("currency");
        localStorage.removeItem("email");
        localStorage.removeItem("isToday");
        localStorage.removeItem("is_add_reg");
        localStorage.removeItem("is_reg_completed");
        localStorage.removeItem("meal_external_tab");
        localStorage.removeItem("lpCr0HsSLPU3FGP5AUbrIiMUh9lcU6ZS");
        localStorage.removeItem("subscribe_tab");
        localStorage.removeItem("setup_tab");
        dispatch(clearToken());
        navigate("/");
      },
    });
  };
  const handleShare = () => {
    if (!qrImage) return;

    const message = `Hi,
Here's your QR code link to access our tiffin services.

Simply click on this link or scan the QR code to view our Menu, Pricing and place orders easily.

QR code link: ${qrImage}

Regards`;

    const encodedMessage = encodeURIComponent(message);

    const isMobile = /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);

    const url = isMobile
      ? `https://wa.me/?text=${encodedMessage}`
      : `https://web.whatsapp.com/send?text=${encodedMessage}`;

    window.open(url, "_blank");
  };

  return (
    <section className=" max-w-7xl rounded-md mx-auto p-4 mt-4 md:mt-5">
      <DecorativeSquares />

      <div className="bg-transparent md:bg-white p-0 md:p-4 rounded-md">
        {/* ================= PAGE TITLE ================= */}
        <div className="text-center md:text-start space-y-2 mb-4 w-full mx-auto relative">
          <h1 className="text-[#191919] text-2xl md:text-3xl font-bold">
            Profile
          </h1>
          <p className="  text-sm text-[#747474]">Update your profile here</p>
        </div>

        <div className="block md:hidden border-b mt-2 mb-2 text-gray-100 w-full shadow-xl"></div>

        {/* ================= MAIN GRID ================= */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-2 md:gap-10 mt-4 md:mt-8">
          {/* ================= LEFT CARD ================= */}
          <div
            className="relative md:bg-gradient-to-br md:from-orange-50 md:to-white
  md:border md:rounded-3xl p-1 md:p-8 text-center md:shadow-sm"
          >
            {isLoading ? (
              // 🔥 Shimmer Skeleton
              <>
                <div className="flex justify-start gap-8">
                  <div className="relative inline-block">
                    <div className="w-24 h-24 rounded-full bg-gray-200 animate-pulse ring-4 ring-white shadow-lg" />
                  </div>

                  <div className="text-start flex flex-col justify-center">
                    <div className="h-6 w-40 bg-gray-200 rounded-md animate-pulse" />
                    <div className="mt-2 h-4 w-32 bg-gray-200 rounded-md animate-pulse" />
                  </div>
                </div>

                <div className="border-t border-[#faded7] mt-8"></div>
              </>
            ) : (
              <>
                <div className="flex justify-start gap-8">
                  <div className="relative inline-block">
                    <ImagePreview
                      src={providerAvtar || previewImg}
                      alt="profile"
                      className="w-24 h-24 rounded-full object-cover ring-4 ring-white shadow-lg"
                    />
                  </div>

                  <div className="text-start flex flex-col justify-center">
                    {/* Identity */}
                    <h2 className="mt-4 text-xl font-semibold text-gray-900">
                      {providerName}
                    </h2>
                    <p className="text-sm text-gray-500">
                      Tiffin Service Provider
                    </p>
                  </div>
                </div>
                <div className="border-t border-[#faded7] mt-8"></div>
              </>
            )}

            {/* ================= QR SECTION ================= */}
            {qrData?.user_service_qr_image && (
              <div className="hidden md:block">
                <div
                  className=" mt-8 bg-transparent
        flex items-center gap-6 "
                >
                  <div className="flex-1 text-start ">
                    <h4 className="text-lg font-semibold text-gray-900">
                      Share Your Business Profile
                    </h4>
                    <p className="text-sm text-gray-500 mt-1">
                      Share this QR code with customers. They can view your
                      Tiffin profile and order directly.
                    </p>
                    <div className="flex justify-center gap-4 mt-4">
                      <PrimaryBtn
                        variant="isIcon"
                        btnName="copy link"
                        icon={<Copy size={16} />}
                        clickEvent={onCopyLink}
                        extraClass="w-[150px]"
                      />
                      <PrimaryBtn
                        variant="isIcon"
                        btnName="Download"
                        icon={<Download size={16} />}
                        clickEvent={onDownload}
                        extraClass="w-[150px]"
                      />
                    </div>
                  </div>

                  <div className="p-4 border rounded-2xl bg-gray-50">
                    {isLoading ? (
                      // 🔥 Shimmer Skeleton
                      <div className="flex flex-col items-center">
                        <div className="w-36 h-36 rounded-md bg-gray-200 animate-pulse ring-4 ring-white shadow-lg" />
                      </div>
                    ) : (
                      <ImagePreview
                        src={qrData.user_service_qr_image}
                        alt="qrcode"
                        className="w-32 h-32"
                      />
                    )}
                  </div>
                </div>
              </div>
            )}
          </div>

          {/* ================= RIGHT CARD ================= */}
          <div className="md:bg-white md:border md:rounded-3xl md:p-6 md:shadow-sm flex flex-col justify-center  ">
            <ul className="space-y-2">
              {profileMenus.map((item, i) => {
                const Icon = item.icon;

                return (
                  <li
                    key={i}
                    onClick={() =>
                      item.path &&
                      navigate(
                        item.path,
                        item.state ? { state: item.state } : undefined,
                      )
                    }
                    className="group cursor-pointer flex items-center justify-between
                  rounded-xl px-2 py-2 md:px-4 md:py-3
                  hover:bg-orange-50 transition"
                  >
                    <div className="flex items-center gap-4">
                      <div
                        className="w-10 h-10 rounded-xl
                      bg-orange-100 text-orange-600
                      flex items-center justify-center
                      group-hover:bg-orange-500
                      group-hover:text-white transition"
                      >
                        <Icon size={18} />
                      </div>

                      <div>
                        <p className="text-sm font-bold text-gray-900">
                          {item.label}
                        </p>
                        <p className="text-xs text-gray-500">{item.desc}</p>
                      </div>
                    </div>

                    <ChevronRight
                      size={18}
                      className="text-gray-400 group-hover:text-orange-500 transition"
                    />
                  </li>
                );
              })}
            </ul>
          </div>
        </div>
        {/* ================= QR SECTION ================= */}
        {qrData?.user_service_qr_image && (
          <div
            className="mt-4 md:mt-14 md:bg-white md:border md:rounded-3xl p-6 block md:hidden
        flex flex-col md:flex-row items-center gap-6 shadow-sm"
          >
            <div className="p-4 border rounded-2xl bg-gray-50">
              {isLoading ? (
                // 🔥 Shimmer Skeleton
                <div className="flex flex-col items-center">
                  <div className="w-36 h-36 rounded-md bg-gray-200 animate-pulse ring-4 ring-white shadow-lg" />
                </div>
              ) : (
                <>
                  {qrData?.user_service_qr_image && (
                    <>
                      <img
                        src={qrData.user_service_qr_image}
                        alt="qrcode"
                        className="w-40 h-40"
                      />
                    </>
                  )}
                </>
              )}
            </div>
            <div className="flex-1 text-center md:text-start">
              <h4 className="text-lg font-semibold text-gray-900">
                Share Your Business Profile
              </h4>
              <p className="text-sm text-gray-500 mt-1">
                Share this QR code with customers. They can view your Tiffin
                profile and order directly.
              </p>
              <div className="flex gap-4 mt-4 justify-center">
                <PrimaryBtn
                  variant="isIcon"
                  btnName="copy link"
                  icon={<Copy size={16} />}
                  clickEvent={onCopyLink}
                  extraClass="w-[150px]"
                />
                <PrimaryBtn
                  variant="isIcon"
                  btnName="Download"
                  icon={<Download size={16} />}
                  clickEvent={onDownload}
                  extraClass="w-[150px]"
                />
              </div>
            </div>
          </div>
        )}

        <div>
          <div className="flex flex-col md:flex-row items-center justify-center md:justify-end pt-4 gap-4">
            <PrimaryBtn
              btnName="Logout"
              variant="isIcon"
              icon={<LogOut size={17} />}
              clickEvent={logout}
            />
            <PrimaryBtn
              btnName="share QR"
              variant="isIcon"
              clickEvent={handleShare}
              icon={<FaWhatsapp />}
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Profile;
